import { Helmet } from 'react-helmet-async';
import React from 'react';
import StakeholderProfileContainer from '../../../containers/projects/StakeholderProfileContainer.jsx';

import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

const StakeholderProfile = ({ projectId, stakeholderId, slug }) => (
  <>
    <Helmet>
      <title>Stakeholder Profile | ChangeSync</title>
    </Helmet>
    <StakeholderProfileContainer
      projectId={projectId}
      stakeholderId={stakeholderId}
      slug={slug}
    />
  </>
);

StakeholderProfile.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  stakeholderId: Number(query.stakeholderId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(StakeholderProfile));
